function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRakutenMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 1.25h-7.5a1.88 1.88 0 00-1.875 1.875v13.75A1.875 1.875 0 006.25 18.75h7.5a1.875 1.875 0 001.875-1.875V3.125A1.88 1.88 0 0013.75 1.25zm.625 15.625a.625.625 0 01-.625.625h-7.5a.626.626 0 01-.625-.625v-1.25h8.75v1.25zm0-2.5h-8.75V5h8.75v9.375zm0-10.625h-8.75v-.625A.633.633 0 016.25 2.5h7.5a.633.633 0 01.625.625v.625z",
    fill: props.color
  }));
}

export default SvgIconRakutenMobile;